import {isSymbolRoot} from '@packages/systems/core/utils/DomTypeUtils';
import {generateGuid} from '@packages/utilities/guid';
import type {Context} from '../types';

// Note: This patch will only be applied on pageTrees (as apposed to symbolTrees)
// It determines if jsonNodes is a pageTree by checking that the first node in the jsonNodeTree is a body element
// If we ever allow symbolizing the body element, migrating pageTree and symbolTree as a unified tree,
// or move the index of the body node in a pageTree, and decide to re-use this patch then the `needed` check will need to be adapted.

export default (context: Context) => {
  const {
    node: {jsonNode},
    tree: {jsonNodes, nodeMap},
    // eslint-disable-next-line webflow/deprecated
    fn: {__DEPRECATED__scanSubtree},
  } = context;
  const {data = {}} = jsonNode;

  // Determine if we're migrating a page tree or a symbol tree
  // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
  const isPageTree = jsonNodes[0].tag === 'body';
  const isSymbolRootInPageTree = isPageTree && isSymbolRoot(data);

  return {
    needed: isSymbolRootInPageTree,
    logData: {
      msg: 'Symbol Root in Page Tree',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // Build a map of _ids to new _ids
      const newGuidMap: Record<string, any> = {};
      newGuidMap[jsonNode._id] = generateGuid();

      __DEPRECATED__scanSubtree(jsonNode, (child) => {
        newGuidMap[child._id] = generateGuid();
      });

      // update ids
      jsonNodes.forEach((_jsonNode) => {
        const oldId = _jsonNode._id;
        const newId = newGuidMap[oldId];

        if (newId) {
          // update the node
          _jsonNode._id = newId;
          // update the nodeMap key where this jsonNode can be referenced
          nodeMap.delete(oldId);
          nodeMap.set(newId, jsonNode);
        }

        // Update childIds
        if (_jsonNode.children && _jsonNode.children.map) {
          _jsonNode.children = _jsonNode.children.map((childId) => {
            return newGuidMap[childId] || childId;
          });
        }
      });

      // Unwrap the rootified symbol into a normal subtree
      if (jsonNode.data) {
        // eslint-disable-next-line webflow/no-delete
        delete jsonNode.data.sym;
      }
    },
  };
};
